import React from 'react';
import MANA_SYMBOLS from '../assets/mana';
import './ManaSymbols.css';

/**
 * Baustein — ManaSymbols.
 * Mana- und Spielsymbole ({W}, {2/U}, {T}, {E} …) als Bilder. Die SVGs liegen gebündelt in
 * `assets/mana/` (erzeugt von `scripts/fetch-mana-symbols.mjs`) — kein Netzwerkzugriff, damit
 * ein Scryfall-Ausfall den Regeltext nicht in Rohtext zurückfallen lässt.
 *
 * Verwendung:
 *   <ManaSymbols manaCost="{2}{W}{U}" size={14} />       — nur Symbole (Manakosten, Farbidentität)
 *   <ManaSymbols.Text text="{T}: Add {G}." size={14} />  — Fließtext mit eingebetteten Symbolen
 *
 * Props: manaCost/text (String), size (px, Standard 16 bzw. 14), className (nur ManaSymbols).
 * Unbekanntes Symbol → runder Platzhalter mit dem Symbolinhalt (title = Symbol).
 */
const SYMBOL_PATTERN = /\{[^}]+\}/g;
const SPLIT_PATTERN = /(\{[^}]+\})/g;

function ManaSymbol({ symbol, size }) {
  const src = MANA_SYMBOLS[symbol];
  if (src) {
    return <img className="mana-symbols__img" src={src} alt={symbol} title={symbol} width={size} height={size} />;
  }
  return (
    <span className="mana-symbols__fallback" title={symbol} style={{ width: size, height: size, fontSize: size * 0.6 }}>
      {symbol.slice(1, -1)}
    </span>
  );
}

export default function ManaSymbols({ manaCost, size = 16, className = '' }) {
  const symbols = manaCost ? manaCost.match(SYMBOL_PATTERN) || [] : [];
  if (symbols.length === 0) return null;
  return (
    <span className={['mana-symbols', className].filter(Boolean).join(' ')}>
      {symbols.map((s, i) => <ManaSymbol key={`${s}-${i}`} symbol={s} size={size} />)}
    </span>
  );
}

ManaSymbols.Text = function ManaSymbolsText({ text, size = 14 }) {
  if (!text) return null;
  return text.split(SPLIT_PATTERN).map((part, i) => (
    /^\{[^}]+\}$/.test(part) ? <ManaSymbol key={i} symbol={part} size={size} /> : <React.Fragment key={i}>{part}</React.Fragment>
  ));
};
